import { Link } from "react-router-dom";
import { Calendar, Phone, MessageCircle } from "lucide-react";
import { useSettings } from "../hooks";

export function StickyBar({ mesaj = "Projeleriniz hakkında bilgi almak istiyorum" }) {
  const s = useSettings();
  const wa = s?.whatsapp || "902160000000";
  const tel = s?.phone || "+902160000000";
  const waUrl = `https://wa.me/${wa}?text=${encodeURIComponent(mesaj)}`;
  return (
    <div className="sabit-cubuk" data-testid="sticky-bar">
      <Link to="/randevu" className="bal" data-testid="sticky-randevu"><Calendar size={16} /> Randevu</Link>
      <a href={waUrl} target="_blank" rel="noopener noreferrer" className="ikon" data-testid="sticky-whatsapp" aria-label="WhatsApp"><MessageCircle size={18} /><span>WhatsApp</span></a>
      <a href={`tel:${tel.replace(/\s/g, "")}`} className="ikon" data-testid="sticky-ara" aria-label="Ara"><Phone size={18} /><span>Ara</span></a>
    </div>
  );
}
